import { MoreHorizontal } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { PipelineAction, PipelineRow } from '@/pages/RenewalPipelinePage.types'
import { useViewOnly } from '@/components/templates/app-shell'

export function RenewalPipelineRowActions({
  row,
  charging,
  onAction,
  onChargeNow,
  onOpenMember,
  onOpenOrganization,
}: {
  row: PipelineRow
  charging: boolean
  onAction: (action: PipelineAction) => void
  onChargeNow: (invoiceId: number) => void
  onOpenMember: (personId: number) => void
  onOpenOrganization?: (organizationId: number) => void
}) {
  const viewOnly = useViewOnly()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-8 w-8 px-0"
          aria-label={`${row.name} actions`}
          onClick={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <MoreHorizontal className="size-4" strokeWidth={1.5} aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {!viewOnly && row.record_payment_available && (
          <DropdownMenuItem onSelect={() => onAction({ kind: 'record-payment', row })}>
            Record payment
          </DropdownMenuItem>
        )}
        {!viewOnly && row.charge_now_available && row.invoice_id && (
          <DropdownMenuItem
            disabled={charging}
            onSelect={() => onChargeNow(row.invoice_id as number)}
          >
            {charging ? 'Charging…' : 'Charge now'}
          </DropdownMenuItem>
        )}
        {!viewOnly && (row.record_payment_available || row.charge_now_available) && (
          <DropdownMenuSeparator />
        )}
        {!viewOnly && row.contact_kind !== 'organization' && (
          <PersonMembershipActions row={row} onAction={onAction} />
        )}
        <DropdownMenuItem
          onSelect={() => {
            if (row.contact_kind === 'organization' && row.organization_id && onOpenOrganization) {
              onOpenOrganization(row.organization_id)
            } else if (row.person_id) {
              onOpenMember(row.person_id)
            }
          }}
        >
          Open contact
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

function PersonMembershipActions({
  row,
  onAction,
}: {
  row: PipelineRow
  onAction: (action: PipelineAction) => void
}) {
  return (
    <>
      {row.suspend_available && (
        <DropdownMenuItem destructive onSelect={() => onAction({ kind: 'suspend', row })}>
          Suspend
        </DropdownMenuItem>
      )}
      {row.renew_available && (
        <DropdownMenuItem onSelect={() => onAction({ kind: 'renew', row })}>
          Renew membership
        </DropdownMenuItem>
      )}
    </>
  )
}
